// # Global constants

export const NO_ROLE = 'N/A';
export const ADMINISTRATOR_ROLE = 'Administrator';
export const REPORTING_ADMIN_ROLE = 'Reporting Admin';
export const PROJECT_ADMIN_ROLE = 'Project Admin';
export const VIEWER_ROLE = 'Viewer';
export const CLIENT_VIEWER_ROLE = 'Client Viewer';